import React, { useEffect, useState, useRef, useContext } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled, { createGlobalStyle } from 'styled-components'
import { createPortal } from 'react-dom'
import b from '../../services/api/Boards'
import l from '../../services/api/Landings'
import { Alert_, AlertContext, Button, Confirmation_, device, Dropdown_, Grey_, Grey_Link, IconSvg, LimitCharacters, Main_, Main_Loader, PageTitle, Partial_Loader } from 'monica-alexandria'
import Crm_Edit_Lead from './components/Crm_Edit_Lead'
import { alertMessage } from '../../utils/messagesAlerts'
import { transformDataForMatrix } from '../../utils/leadUtils'
import { exportCrmLeads } from './crmExport'
import Crm_Leads_Date from './components/Crm_Leads_Date'
import Crm_Leads_Table from './components/Crm_Leads_Table'
import { useCrmFormSchema } from './hooks/useCrmFormSchema'

import { useCRMFilters } from './hooks/useCRMFilters'
import { useBoardColumns } from './hooks/useBoardColumns'
import { useCRMLeadTable } from './hooks/useCRMLeadTable'
import { useLeadEditing } from './hooks/useLeadEditing'
import { useColumnDnD } from './hooks/useColumnDnD'
import { useAutoScrollDrag } from './hooks/useAutoScrollDrag'
import Crm_Create_Lead from './components/Crm_Create_Lead'
import Crm_Kanban_Board from './components/Crm_Kanban_Board'
import Crm_Archived_Leads from './components/Crm_Archived_Leads'
import Crm_Restore_Leads from './components/Crm_Restore_Leads'
import Crm_Import_Leads from './components/Crm_Import_Leads'
import Crm_Share_Panel from './components/Crm_Share_Panel'
import Crm_Board_Actions from './components/Crm_Board_Actions'
import { useClickOutside } from '../../hooks/useClickOutside'
import Crm_Toolbar from './components/Crm_Toolbar'
import { useCRMContext } from '../../context/CrmContext'
import store from '../../redux/store'
import { get_user_avatar_src } from '../../helpers/userAvatar'
import { get_settings, get_user_images } from '../../services/api/Users'
const clients = require('../../config/index').config

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  width: 100%;
  .Grey{
    display: none;
  }

  @media ${device.md}{
    .Grey{
      display: block;
    }
  }
`;

const isValidEmailAddress = (value = "") => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
};

const MAX_BOARD_COLLABORATORS = 3;

const SearchIconButton = styled.div`
  width: 36px;
  height: 36px;
  cursor: pointer;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: ${({theme}) => theme.greyLight || "#F1F2F6"};
  transition: 0.25s;
  
  &:hover {
    background: ${({theme}) => theme.greyMid || "#D9DBE0"};
  }
`;

const InputReveal = styled.input`
  min-width: 30rem;
  opacity :1 ;
  border: none;
  background: ${p=>p.theme.mid};
  padding: var(--normalPads);
  border-radius: 8px;
  transition: width .3s ease, opacity .25s ease;
  font-size: 14px;
  height: 4rem;
  width: 100%;

  color: ${p=> p.theme.color};
  @media ${device.md}{
    width: ${({active}) => (active ? "100%" : "0")};
    min-width: ${({active}) => (active ? "20rem" : "0")};
    opacity: ${({active}) => (active ? 1 : 0)};
    padding: ${({active}) => (active ? "var(--smallPads)" : "0")};
  }

  &:focus { 
    outline: none;
  }
`;

const GlobalPatch = createGlobalStyle`
  #silktide-cookie-icon{
    display: none !important;
  }
`;

const Crm = styled.div`
  position: relative;
  user-select: none;
  /* padding-left: 6rem; */
`;

const CrmWrapper = styled.div`
  /* display: grid;
  grid-template-columns: auto ; */
`;

const CrmTitle = styled(PageTitle)`
  display: grid;
  grid-template-columns: auto auto;
  padding: 2rem 4rem 1rem 4rem;
  justify-content: space-between;

  @media ${device.sm} {
    padding-left: 2rem;
    padding-right: 2rem;
    /* grid-template-columns: auto 1fr; */
    justify-content: space-between;
/* 
    .FormGroup{
      grid-column-start: 1;
      grid-column-end: 3;
    } */
  }
`;


const CrmQuestSelect = styled.div`
  margin:0rem 4rem 1rem 4rem;

  @media ${device.md}{
    margin : 0rem 2rem 1rem 2rem;
  }
 
`

const CrmQuestSelectWrapper = styled.div`
  /* max-width: 30rem; */
  select {
    padding-top: 0.5rem;
  }
  svg {
    height: 0.8rem;
    top: 1.2rem;
    right: 1rem;
  }
  label{
    display: none;
  }
  @media ${device.md}{
    max-width: 20rem;
  }

`

const CrmTitleText = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

const CrmBoardWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  cursor: grab;

  &:active{
    cursor: grabbing;
  }

`;


const CrmLeadsNo = styled.div`
  text-align: center;

  img {
    width: 100%;
    display: block;
    max-width: 40rem;
    margin: 2rem auto;
    opacity: 0.5;
  }

  h1, h5 { color: var(--greyDark); }
`;

const CrmActionsRight = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  .selectedRange {
    border: 2px solid var(--main);
  }

  @media ${device.md}{
    display: ${(p) => (p.active ? "none" : "flex")};

    .FiltersBtn span{
      display: none;
    }
  }
`;

const CrmActions = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: right;
  gap: 4rem;
  width: 100%;

  .FormGroup{
    width: 100%;
  }

  @media ${device.md} {
    gap: 0.5rem;
    button{
      span{
        display: none;
      }
    }
  }

  @media ${device.sm} {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 2;
    justify-content: flex-end;
  }
`;


const ShareBoardTrigger = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  height: 4.4rem;
  padding: 0 1rem 0 0.6rem;
  /* border: 1px solid ${(p) => p.theme.low};
  border-radius: 999px;
  background: ${(p) => p.theme.mid};
  color: ${(p) => p.theme.color}; */
  font-size: 1.45rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    /* transform: translateY(-1px); */
    border-color: var(--main);
  }

  @media ${device.md} {
    display: none;
  }
`;

const ShareAvatarStack = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.2rem;
`;

const ShareAvatar = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(p) => p.background || "var(--main)"};
  color: ${(p) => p.color || "var(--white)"};
  /* border: 1px solid var(--main); */
    border:1px solid ${(p) => p.border || "var(--main)"};
  cursor: pointer;
  position: relative;
  z-index: ${(p) => p.zIndex || 1};

  margin-left: ${(p) => (p.index === 0 ? "0" : "-0.8rem")};
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
  border: 2px solid ${(p) => p.theme.low || "var(--main)"};

  svg {
    width: 1.5rem;
    fill: var(--main);
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    display: block;
  }

  p {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: inherit;
  }
`;

const CollaboratorCard = styled.div`
  position: fixed;
  z-index: 1002;
  width: 28rem;
  background: ${(p) => p.theme.mid};
  border: 1px solid ${(p) => p.theme.low};
  border-radius: var(--smallRadius);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.28);
  overflow: hidden;
`;

const CollaboratorCardTop = styled.div`
  padding: var(--normalPads);
  background: linear-gradient(180deg, rgba(92, 188, 189, 0.22), rgba(92, 188, 189, 0.08));
  display: flex;
  gap: 1.2rem;
  align-items: center;


  h4{
    color: ${(p) => p.theme.color};
  }

  p {
    margin: 0.35rem 0 0;
    color: ${(p) => p.theme.color};
    word-break: break-word;
  }
`;

const CollaboratorCardAvatar = styled.div`
  width: 7rem;
  height: 7rem;
  min-width: 7rem;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: ${(p) => p.background || "var(--main)"};
  border: 2px solid ${(p) => p.border || "var(--main)"};

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    display: block;
  }
`;

const CollaboratorCardBody = styled.div`
  padding: var(--normalPads);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const CollaboratorCardRow = styled.div`
  padding: 0.3rem 0;

  h6 {
    margin: 0 0 0.25rem;
    font-size: 1.15rem;
    opacity: 0.8;
    /* color: var(--greyDark); */
    color: ${(p) => p.theme.color};
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  p {
    margin: 0;
    font-size: 1.45rem;
    color: ${(p) => p.theme.color};
  }
`;

const ShareBtn = styled(Button)`
  margin-left: 0.4rem;
  background: ${p => p.theme.low};
  border-radius: var(--normalRadius);
  height: 4rem;

  svg{
    fill: ${p => p.theme.color};
    width: 1.5rem;
  }


`

const ShareTriggerText = styled.div`
  /* display: flex;/ */
  width: 100%;
  background: ${p => p.theme.mid};
  padding: var(--smallPads);
  border-radius: var(--smallRadius);
  /* flex-direction: column;
  align-items: flex-start;
  line-height: 1.1; */

  strong {
    font-size: 1.45rem;
    color: ${(p) => p.theme.color};
  }

  p {
    font-size: 1.15rem;

  }

  @media ${device.md} {
    display: none;
  }
`;

const SharedBoardPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  height: 4.4rem;
  padding: 0 1rem 0 0.6rem;
  font-size: 1.45rem;
  font-weight: 700;

  ${ShareAvatarStack} {
    margin-right: 0;
    flex-shrink: 0;
  }

  @media ${device.md} {
    display: none;
  }

`;

const getRenderableEmail = (emailValue) => {
  if (typeof emailValue === "string") return emailValue;
  if (emailValue && typeof emailValue === "object") {
    return emailValue.email || "";
  }
  return "";
};

const getInitials = (value = "") => {
  const normalized = String(value || "").trim();
  if (!normalized) return "?";

  const source = normalized.includes("@") ? normalized.split("@")[0] : normalized;
  const parts = source.split(/[._\s-]+/).filter(Boolean);
  const initials = parts.slice(0, 2).map((part) => part[0]?.toUpperCase()).join("");
  return initials || normalized.slice(0, 2).toUpperCase();
};

const prettifyCollaboratorName = (value = "") => {
  const normalized = String(value || "").trim();
  if (!normalized) return "";

  const source = normalized.includes("@") ? normalized.split("@")[0] : normalized;
  return source
    .split(/[._\s-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const getCollaboratorAvatarSrc = (userValue = {}) => {
  if (userValue?.rawUser) {
    return get_user_avatar_src({
      user: userValue.rawUser,
      userId: userValue?.userId || userValue?.rawUser?.sub || userValue?.rawUser?.userId || "",
    });
  }

  return get_user_avatar_src({
    user: {
      sub: userValue?.userId || "",
      userId: userValue?.userId || "",
      email: userValue?.email || "",
      username: userValue?.username || userValue?.email || "",
      firstname: userValue?.firstname || "",
      lastname: userValue?.lastname || "",
      profileAvatar: userValue?.profileAvatar || "",
      images: userValue?.images || {},
      updatedAt: userValue?.updatedAt || null,
    },
    userId: userValue?.userId || "",
  });
};

const getPreviewUsersWithOverflow = (users = [], visibleCount = 4) => {
  const normalizedUsers = Array.isArray(users) ? users : [];
  const safeVisibleCount = Math.max(0, Number(visibleCount) || 0);
  const visibleUsers = normalizedUsers.slice(0, safeVisibleCount);
  const overflowCount = Math.max(0, normalizedUsers.length - safeVisibleCount);

  return {
    visibleUsers,
    hasOverflow: overflowCount > 0,
    overflowCount,
  };
};


function CrmTableView({
  columns,
  loadLeadBatch,
  leadColumnMap,
  multipleCustomFields,
  openLeadEditor,
  pagination,
  selectedLeadIds,
  selectedQuestId,
  setLeadColumnMap,
  setPagination,
  selectionMode,
  toggleLeadSelection,
  toggleSelectAllVisible,
}) {
  return (
    <Crm_Leads_Table
      onClick={(colId, lead) => openLeadEditor(colId, lead)}
      selectedQuestId={selectedQuestId}
      columns={columns}
      get_leads={loadLeadBatch}
      pagination={pagination}
      setPagination={setPagination}
      multipleCustomFields={multipleCustomFields}
      leadColumnMap={leadColumnMap}
      setLeadColumnMap={setLeadColumnMap}
      selectionMode={selectionMode}
      selectedLeadIds={selectedLeadIds}
      toggleLeadSelection={toggleLeadSelection}
      toggleSelectAllVisible={toggleSelectAllVisible}
    />
  );
}


export default function CRM() {
  const { questId } = useParams();
  const { selectedQuestId } = useCRMContext();
  const { search } = useLocation();
  const shareToken = new URLSearchParams(search).get("shareToken") || "";

  // Give each board its own state so pending responses cannot update another board.
  return <CRMBoard key={JSON.stringify([questId || selectedQuestId, shareToken])} />;
}

function CRMBoard() {
  const { t } = useTranslation();
  const { questId, lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { alerts, setAlerts } = useContext(AlertContext);
  const currentUser = store.getState()?.user?.user || {};
  const currentUserId = currentUser?.sub;
  const currentUserEmail = getRenderableEmail(currentUser?.email);
  const currentUserName = [currentUser?.firstname, currentUser?.lastname].filter(Boolean).join(" ").trim();
  const crmColumnUpdateRef = useRef(null);
  const [showSearch, setShowSearch] = useState(false);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [leadEditorInitialTab, setLeadEditorInitialTab] = useState("details");
  const [newLead, setNewLead] = useState([])
  const onSearchToggle = () => setShowSearch(true);
  const [localNotes, setLocalNotes] = useState([]);
  const [moreActions, setMoreActions] = useState(false);
  const [viewArchived, setViewArchived] = useState(false);
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [confirmBulkAction, setConfirmBulkAction] = useState(false);
  const [bulkActionLoading, setBulkActionLoading] = useState(false);
  const [sharePanelOpen, setSharePanelOpen] = useState(false);
  const [shareEmail, setShareEmail] = useState("");
  const [pendingShareEmails, setPendingShareEmails] = useState([]);
  const [shareLoading, setShareLoading] = useState(false);
  const [sharedUsers, setSharedUsers] = useState([]);
  const [boardOwnerShareUser, setBoardOwnerShareUser] = useState(null);
  const [currentUserAvatarUser, setCurrentUserAvatarUser] = useState(currentUser);
  const [activeCollaboratorCard, setActiveCollaboratorCard] = useState(null);
  const [shareStatus, setShareStatus] = useState(null);
  const [linkSharingEnabled, setLinkSharingEnabled] = useState(false);
  const [boardShareToken, setBoardShareToken] = useState("");
  const newActionsRef = useRef(null);
  const desktopMoreActionsRef = useRef(null);
  const mobileMoreActionsRef = useRef(null);
  const collaboratorCardRef = useRef(null);
  useClickOutside(newActionsRef, () => setMoreActions(false), moreActions === 'new');
  useClickOutside(
    desktopMoreActionsRef,
    () => setMoreActions(false),
    moreActions === 'more'
  );
  useClickOutside(
    mobileMoreActionsRef,
    () => setMoreActions(false),
    moreActions === 'more-mobile'
  );
  useClickOutside(collaboratorCardRef, () => setActiveCollaboratorCard(null), Boolean(activeCollaboratorCard));

  const shareToken = new URLSearchParams(location.search).get("shareToken") || "";
  const showShareAlert = (message, status = "Success") => {
    alertMessage(alerts, setAlerts, message, status);
  };

  const openSharePanel = async (mode = "owner") => {
    if (!selectedQuestId) return;
    if (mode === "owner" && !canManageBoardSharing) return;

    setSharePanelOpen(true);
    setShareEmail("");
    setPendingShareEmails([]);
    setShareStatus(null);
    setShareLoading(true);

    const responseValue = await b.getBoardSharing(selectedQuestId);
    setSharedUsers(responseValue?.data?.sharedWith || []);
    setBoardOwnerShareUser(responseValue?.data?.owner || null);
    setLinkSharingEnabled(Boolean(responseValue?.data?.linkSharing?.enabled));
    setBoardShareToken(String(responseValue?.data?.linkSharing?.token || ""));
    setShareLoading(false);
  };

  const closeSharePanel = () => {
    setSharePanelOpen(false);
    setShareEmail("");
    setPendingShareEmails([]);
    setShareStatus(null);
    setShareLoading(false);
  };

  const ensureLinkSharingEnabled = async () => {
    if (linkSharingEnabled && boardShareToken) {
      return boardShareToken;
    }

    const responseValue = await b.updateBoardLinkSharing(selectedQuestId, true);
    if (responseValue === false || responseValue?.data?.error) {
      throw new Error("Could not enable link sharing");
    }

    const nextToken = String(responseValue?.data?.linkSharing?.token || "");
    setLinkSharingEnabled(Boolean(responseValue?.data?.linkSharing?.enabled));
    setBoardShareToken(nextToken);
    return nextToken;
  };

  const handleCopyBoardLink = async () => {
    try {
      const nextToken = await ensureLinkSharingEnabled();
      const link = `${window.location.origin}/${lang}/crm/board/${selectedQuestId}?shareToken=${encodeURIComponent(nextToken)}`;
      await navigator.clipboard.writeText(link);
      showShareAlert(t("Board link copied"), "Success");
    } catch (error) {
      showShareAlert(t("Could not copy board link"), "Error");
    }
  };

  const handleToggleLinkSharing = async () => {
    setShareLoading(true);
    const nextEnabled = !linkSharingEnabled;
    const responseValue = await b.updateBoardLinkSharing(selectedQuestId, nextEnabled);

    if (responseValue === false || responseValue?.data?.error) {
      showShareAlert(t("Could not update link access right now"), "Error");
      setShareLoading(false);
      return;
    }

    setLinkSharingEnabled(Boolean(responseValue?.data?.linkSharing?.enabled));
    setBoardShareToken(String(responseValue?.data?.linkSharing?.token || ""));
    showShareAlert(
      nextEnabled ? t("Anyone with the link can access this board") : t("Link access disabled"),
      "Success"
    );
    setShareLoading(false);
  };

  const addPendingShareEmail = () => {
    const normalizedEmail = String(shareEmail || "").trim().toLowerCase();
    const remainingInviteSlots = Math.max(0, MAX_BOARD_COLLABORATORS - sharedUsers.length - pendingShareEmails.length);

    if (!normalizedEmail) {
      setShareStatus({ type: "error", text: t("Enter an email to share this board") });
      return false;
    }

    if (!isValidEmailAddress(normalizedEmail)) {
      setShareStatus({ type: "error", text: t("Enter a valid email address") });
      return false;
    }

    if (normalizedEmail === currentUserEmail) {
      setShareStatus({ type: "error", text: t("Cannot share with yourself") });
      return false;
    }

    const alreadyShared = sharedUsers.some(
      (sharedValue) => getRenderableEmail(sharedValue?.email) === normalizedEmail
    );
    if (alreadyShared) {
      setShareStatus({ type: "error", text: t("This person already has access") });
      return false;
    }

    const alreadyPending = pendingShareEmails.includes(normalizedEmail);
    if (alreadyPending) {
      setShareStatus({ type: "error", text: t("This email is already in the list") });
      return false;
    }

    if (remainingInviteSlots <= 0) {
      setShareStatus({ type: "error", text: t("You can invite up to 3 people to this board"), code: "B4001" });
      return false;
    }

    setPendingShareEmails((prev) => [...prev, normalizedEmail]);
    setShareEmail("");
    setShareStatus(null);
    return true;
  };

  const removePendingShareEmail = (emailValue) => {
    setPendingShareEmails((prev) => prev.filter((value) => value !== emailValue));
  };

  const refreshBoardSharingState = async () => {
    const sharingResponse = await b.getBoardSharing(selectedQuestId, shareToken);
    if (sharingResponse === false) {
      return false;
    }

    setSharedUsers(sharingResponse?.data?.sharedWith || []);
    setBoardOwnerShareUser(sharingResponse?.data?.owner || null);
    if (canManageBoardSharing) {
      setLinkSharingEnabled(Boolean(sharingResponse?.data?.linkSharing?.enabled));
      setBoardShareToken(String(sharingResponse?.data?.linkSharing?.token || ""));
    }

    return sharingResponse;
  };

  const handleShareBoard = async () => {
    const nextPendingEmails = [...pendingShareEmails];
    const normalizedInputEmail = String(shareEmail || "").trim().toLowerCase();
    const availableInviteSlots = Math.max(0, MAX_BOARD_COLLABORATORS - sharedUsers.length);

    if (!nextPendingEmails.length && !normalizedInputEmail) {
      setShareStatus({ type: "error", text: t("Add at least one email") });
      return;
    }

    if (normalizedInputEmail) {
      const added = addPendingShareEmail();
      if (!added) return;
      nextPendingEmails.push(normalizedInputEmail);
    }

    if (!nextPendingEmails.length) {
      setShareStatus({ type: "error", text: t("Add at least one email") });
      return;
    }

    if (nextPendingEmails.length > availableInviteSlots) {
      setShareStatus({ type: "error", text: t("You can invite up to 3 people to this board"), code: "B4001" });
      return;
    }

    setShareLoading(true);

    for (const emailValue of nextPendingEmails) {
      const responseValue = await b.shareBoard(selectedQuestId, emailValue);
      const responseCode = String(responseValue?.data?.code || responseValue?.code || "");
      const hasErrorCode = /^(?:[A-Z]+)?(?:4|5)\d{3}$/.test(responseCode);
      const shareError = responseValue === false
        ? t("Could not share board right now")
        : String(
            (hasErrorCode ? responseValue?.data?.msg : "") ||
            responseValue?.data?.error ||
            responseValue?.error ||
            responseValue?.message ||
            ""
          ).trim() ||
          (responseValue?.status && responseValue.status >= 400
            ? t("Could not share board right now")
            : null);

      if (shareError) {
        if (responseCode === "B4000" || responseCode === "B4001") {
          setShareStatus({ type: responseCode === "B4000" ? "warning" : "error", text: shareError, code: responseCode });
        } else {
          showShareAlert(shareError, "Error");
        }
        setShareLoading(false);
        return;
      }
    }

    const refreshedSharingState = await refreshBoardSharingState();
    if (refreshedSharingState === false) {
      showShareAlert(t("Could not refresh collaborators right now"), "Error");
      setShareLoading(false);
      return;
    }

    setPendingShareEmails([]);
    setShareEmail("");
    setShareStatus(null);
    showShareAlert(
      nextPendingEmails.length > 1 ? t("Invitations sent") : t("Board shared successfully"),
      "Success"
    );
    setShareLoading(false);
  };

  const handleUnshareBoard = async (sharedValue) => {
    setShareLoading(true);
    const responseValue = await b.unshareBoard(
      selectedQuestId,
      sharedValue?.email,
      sharedValue?.userId
    );

    if (responseValue === false || responseValue?.data?.error) {
      showShareAlert(t("Could not remove access right now"), "Error");
      setShareLoading(false);
      return;
    }

    const refreshedSharingState = await refreshBoardSharingState();
    if (refreshedSharingState === false) {
      showShareAlert(t("Could not refresh collaborators right now"), "Error");
      setShareLoading(false);
      return;
    }

    setShareStatus(null);
    showShareAlert(t("Access removed"), "Success");
    setShareLoading(false);
  };


  
  const [archivedState, setArchivedState] = useState({items: [], skip: 0, hasMore: true,loading: false});

  const onBlurHandler = () => {
    if (!searchQuery) setShowSearch(false);
  };

  /** ============= VIEW MODE ============= */
  const [view, setView] = useState(() =>
    localStorage.getItem("crm_view") === "table" ? "table" : "kanban"
  );

  /** ============= QUESTS ============= */
  const { quests, archivedQuests, selectedQuestId: contextSelectedQuestId, setSelectedQuestId, loading: questsLoading, loadError, availabilityWarning: listAvailabilityWarning,} = useCRMContext();
  const selectedQuestId = questId || contextSelectedQuestId;
  const selectedQuest =
    quests?.find((q) => String(q._id) === String(selectedQuestId)) ||
    archivedQuests?.find((q) => String(q._id) === String(selectedQuestId));
  const boardTitle = selectedQuest?.name ||
    `${selectedQuest?.questionnaires?.[0]?.answer || ""} ${
      LimitCharacters(selectedQuest?.questionnaires?.[1]?.answer || "", 15)
    }`.trim();
  const canManageBoardSharing = String(selectedQuest?.userId || "") === String(currentUserId || "");
  const isQuestBoardOwner = String(selectedQuest?.userId || "") === String(currentUserId || "");
  const sharePreviewUsers = [
    ...sharedUsers,
    {
      email: getRenderableEmail(boardOwnerShareUser?.email) || currentUserEmail,
      userId: currentUserId || "",
      isOwner: true,
      isCurrentUser: true,
      name: currentUserName,
      rawUser: currentUserAvatarUser,
      username: currentUserAvatarUser?.username || currentUserEmail,
      firstname: currentUserAvatarUser?.firstname || "",
      lastname: currentUserAvatarUser?.lastname || "",
      profileAvatar: currentUserAvatarUser?.profileAvatar || "",
      images: currentUserAvatarUser?.images || {},
      updatedAt: currentUserAvatarUser?.updatedAt || null,
    },
  ]
    .filter((userValue, index, array) => {
      const identityKey = String(userValue?.userId || getRenderableEmail(userValue?.email) || "");
      return identityKey && array.findIndex((candidate) => String(candidate?.userId || getRenderableEmail(candidate?.email) || "") === identityKey) === index;
    });
  const sharedBoardPreviewUsers = [
    boardOwnerShareUser ? {
      ...boardOwnerShareUser,
      userId: boardOwnerShareUser?.userId || selectedQuest?.userId || "",
      isOwner: true,
      isCurrentUser: String(boardOwnerShareUser?.userId || selectedQuest?.userId || "") === String(currentUserId || "")
        || getRenderableEmail(boardOwnerShareUser?.email) === currentUserEmail,
      name: boardOwnerShareUser?.name || t("Owner"),
    } : {
      userId: selectedQuest?.userId || "",
      isOwner: true,
      isCurrentUser: String(selectedQuest?.userId || "") === String(currentUserId || ""),
      name: t("Owner"),
    },
    ...sharedUsers,
    {
      email: currentUserEmail,
      userId: currentUserId || "",
      isOwner: false,
      isCurrentUser: true,
      name: currentUserName,
      rawUser: currentUserAvatarUser,
      username: currentUserAvatarUser?.username || currentUserEmail,
      firstname: currentUserAvatarUser?.firstname || "",
      lastname: currentUserAvatarUser?.lastname || "",
      profileAvatar: currentUserAvatarUser?.profileAvatar || "",
      images: currentUserAvatarUser?.images || {},
      updatedAt: currentUserAvatarUser?.updatedAt || null,
    },
  ]
    .filter((userValue, index, array) => {
      const identityKey = String(userValue?.userId || getRenderableEmail(userValue?.email) || "");
      return identityKey && array.findIndex((candidate) => String(candidate?.userId || getRenderableEmail(candidate?.email) || "") === identityKey) === index;
    });
  const desktopOwnerPreview = getPreviewUsersWithOverflow(sharePreviewUsers, 4);
  const desktopCollaboratorPreview = getPreviewUsersWithOverflow(sharedBoardPreviewUsers, 4);
  const mobileOwnerPreview = getPreviewUsersWithOverflow(sharePreviewUsers, 2);
  const mobileCollaboratorPreview = getPreviewUsersWithOverflow(sharedBoardPreviewUsers, 2);

  const openCollaboratorCard = (event, userValue) => {
    event.stopPropagation();

    const rect = event.currentTarget.getBoundingClientRect();
    const email = getRenderableEmail(userValue?.email);
    const displayName = userValue?.name || (userValue?.isCurrentUser ? currentUserName : "") || prettifyCollaboratorName(email) || email;
    const avatarSrc = getCollaboratorAvatarSrc(userValue);

    setActiveCollaboratorCard({
      top: rect.bottom + 10,
      left: rect.left,
      user: {
        email,
        displayName,
        role: userValue?.isOwner ? t("Owner") : t("Collaborator"),
        initials: getInitials(displayName || email),
        avatarSrc,
        background: userValue?.isOwner ? "var(--main)" : "#f4c7a1",
        color: userValue?.isOwner ? "var(--white)" : "#5d3415",
        border: userValue?.isOwner ? "2px solid var(--main)" : "2px solid #f4c7a1",
      },
    });
  };

  const ownerResolvedName =
    boardOwnerShareUser?.name ||
    [boardOwnerShareUser?.firstname, boardOwnerShareUser?.lastname].filter(Boolean).join(" ").trim() ||
    prettifyCollaboratorName(
      getRenderableEmail(boardOwnerShareUser?.email) ||
      boardOwnerShareUser?.username ||
      ""
    ) ||
    t("Owner");
  const ownerResolvedEmail =
    getRenderableEmail(boardOwnerShareUser?.email) ||
    String(boardOwnerShareUser?.username || "").trim();
  const effectiveSharePanelMode = canManageBoardSharing ? "owner" : "collaborators";
  const ownerPanelName = effectiveSharePanelMode === "owner" ? t("You") : ownerResolvedName;
  const ownerPanelEmail = effectiveSharePanelMode === "owner" ? currentUserEmail : ownerResolvedEmail;
  const collaboratorListUsers = sharedUsers.filter((sharedValue) => {
    const sharedEmail = getRenderableEmail(sharedValue?.email);
    const sharedUserId = String(sharedValue?.userId || "");
    const isCurrentUserShared = sharedEmail === currentUserEmail || (sharedUserId && sharedUserId === String(currentUserId || ""));
    const isOwnerShared = ownerPanelEmail && sharedEmail === ownerPanelEmail;

    if (effectiveSharePanelMode === "owner") {
      return !isOwnerShared;
    }

    return !isCurrentUserShared && !isOwnerShared;
  });
  const remainingCollaboratorSlots = Math.max(0, MAX_BOARD_COLLABORATORS - sharedUsers.length);
  const shareLimitReached = remainingCollaboratorSlots <= 0;

  useEffect(() => {
    if (!selectedQuestId) return;
    localStorage.setItem(
      `crm_board_last_seen_${selectedQuestId}`,
      new Date().toISOString()
    );
  }, [selectedQuestId]);

  useEffect(() => {
    if (questId && String(contextSelectedQuestId) !== String(questId)) {
      setSelectedQuestId(questId);
    }
  }, [questId, contextSelectedQuestId, setSelectedQuestId]);

  useEffect(() => {
    let mounted = true;

    if (!currentUserId) {
      setCurrentUserAvatarUser(currentUser);
      return undefined;
    }

    const hydrateCurrentUserAvatar = async () => {
      const [settingsResponse, imagesResponse] = await Promise.all([
        get_settings(currentUserId),
        get_user_images(currentUserId),
      ]);

      if (!mounted) return;

      setCurrentUserAvatarUser({
        ...currentUser,
        ...(settingsResponse?.data?.data || {}),
        images: {
          ...(currentUser?.images || {}),
          ...(imagesResponse?.data?.data?.images || {}),
        },
      });
    };

    hydrateCurrentUserAvatar();

    return () => {
      mounted = false;
    };
  }, [currentUser, currentUserId]);

  useEffect(() => {
    let mounted = true;

    if (!selectedQuestId) {
      setSharedUsers([]);
      setBoardOwnerShareUser(null);
      return undefined;
    }

    const loadSharingPreview = async () => {
      const responseValue = await b.getBoardSharing(selectedQuestId, shareToken);
      if (!mounted) return;
      setSharedUsers(responseValue?.data?.sharedWith || []);
      setBoardOwnerShareUser(responseValue?.data?.owner || null);
      if (isQuestBoardOwner) {
        setLinkSharingEnabled(Boolean(responseValue?.data?.linkSharing?.enabled));
        setBoardShareToken(String(responseValue?.data?.linkSharing?.token || ""));
      }
    };

    loadSharingPreview();

    return () => {
      mounted = false;
    };
  }, [isQuestBoardOwner, selectedQuestId, shareToken]);

  /** ============= FILTERS & SEARCH ============= */
  const {
    dateFilters,
    setDateFilters,
    customRange,
    setCustomRange,
    callFilters,
    setCallFilters,
    sourceFilter,
    setSourceFilter,
    searchQuery,
    setSearchQuery,
    getBackendDates,
    searchTimer,
  } = useCRMFilters();

  const [pendingFilterRefresh, setPendingFilterRefresh] = useState(false);
  const activeFilterCount = Number(sourceFilter !== 'all')
    + Number(Boolean(dateFilters.value && dateFilters.value !== "all"))
    + [callFilters.timing, callFilters.assignee, callFilters.outcome]
      .reduce((total, value) => total + (Array.isArray(value) ? value.length : Number(Boolean(value && value !== "all"))), 0);

  /** ============= BOARD (KANBAN) ============= */
  const { columns, setColumns, columnOrder, setColumnOrder, boardMeta, boardReady, loadColumn, loadBoard, columnLoading, columnHasMore, }
   = useBoardColumns({questId: selectedQuestId, filters: { getBackendDates, callFilters, sourceFilter }, shareToken, searchQuery,
  });
  const fallbackBoardName = boardMeta?.questName || "";
  const displayBoardName = boardTitle || fallbackBoardName || t("Board");
  const isBoardOwner = String(selectedQuest?.userId || boardMeta?.questUserId || "") === String(currentUserId || "");
  const { definition: formDefinition, schema: formSchema, loading: schemaLoading, error: schemaError,
    reload: reloadSchema } = useCrmFormSchema({ boardId: selectedQuestId,
      isSidequest: Boolean(selectedQuest?.isSidequest || boardMeta?.kind === 'sidequest'), shareToken });
  const hasLoadedFormSchema = Boolean(formDefinition) && !schemaLoading && !schemaError;

  /** ============= TABLE LEADS ============= */
  const {pagination, loadLeadBatch, multipleCustomFields, leadColumnMap, setLeadColumnMap, setPagination, } = useCRMLeadTable({
    questId: selectedQuestId, transform: (leads) => transformDataForMatrix(leads, t), filters: { customRange, callFilters, sourceFilter }, shareToken,
  });
  const visibleTableLeadIds = pagination?.leads?.map((lead) => String(lead._id || lead.id)) || [];
  const visibleKanbanLeadIds = columnOrder.flatMap((colId) =>
    (columns[colId]?.items || []).map((lead) => String(lead._id || lead.id))
  );
  const visibleLeadIds = view === "table" ? visibleTableLeadIds : visibleKanbanLeadIds;
  const allVisibleSelected =
    visibleLeadIds.length > 0 &&
    visibleLeadIds.every((leadId) => selectedLeadIds.includes(leadId));

  /** ============= LEAD EDITING ============= */
  const {editingLead, setEditingLead, activeColumnId, setActiveColumnId, originalColumnId, openLeadEditor, saveLead,closeLeadEditor, moveLeadBetweenColumns}
   = useLeadEditing({questId: selectedQuestId, columns, setColumns, crmColumnUpdateRef,  alert: (msg) => alertMessage(alerts, setAlerts, msg, "Error"), isSliderOpen, setIsSliderOpen, shareToken
  });

  useEffect(() => {
    const target = location.state?.crmCallTarget;
    if (!target?.lead || String(target.questId || "") !== String(selectedQuestId || "")) return;

    setLeadEditorInitialTab("schedule");
    openLeadEditor(target.columnId || columnOrder[0] || "new", target.lead);
  }, [location.state, selectedQuestId]);

  useEffect(() => {
    if (isSliderOpen !== "edit") setLeadEditorInitialTab("details");
  }, [isSliderOpen]);

  /** ============= DnD (Columns & Leads) ============= */
  const { onDragEnd } = useColumnDnD({
    questId: selectedQuestId,
    columns,
    setColumns,
    columnOrder,
    setColumnOrder,
    alert: (msg) => alertMessage(alerts, setAlerts, msg, "Error"),
    shareToken,
  });

  /** ============= DRAG AUTOSCROLL + DRAG-SCROLL ============= */
  const boardRef = useRef(null);
  const isDraggingCardRef = useRef(false);
  const pos = useRef({ left: 0, x: 0, isDown: false });

  useAutoScrollDrag(boardRef, isDraggingCardRef);

  const onMouseDown = (e) => {
    const board = boardRef.current;
    if (!board) return;
    if (e.target.closest("[data-dnd-draggable]")) return;
    pos.current.isDown = true;
    pos.current.left = board.scrollLeft;
    pos.current.x = e.clientX;
  };

  const onMouseMove = (e) => {
    if (!pos.current.isDown) return;
    const board = boardRef.current;
    const dx = e.clientX - pos.current.x;
    board.scrollLeft = pos.current.left - dx;
  };

  const onMouseUp = () => {
    pos.current.isDown = false;
  };

  /** ============= COLUMN DELETE ============= */
  const [columnDlt, setColumnDlt] = useState(false);

  const deleteColumn = async () => {
    if (!columnDlt) return;

    const prevColumns = { ...columns };
    const prevOrder = [...columnOrder];

    const newColumns = { ...columns };
    delete newColumns[columnDlt];
    const newOrder = columnOrder.filter((id) => id !== columnDlt);

    setColumns(newColumns);
    setColumnOrder(newOrder);

    try {
      await b.deleteColumn(selectedQuestId, columnDlt, shareToken);
      setColumnDlt(false);
      alertMessage(alerts, setAlerts, t("Column deleted"), "Success");
    } catch (err) {
      console.error("Delete column failed", err);
      setColumns(prevColumns);
      setColumnOrder(prevOrder);
      alertMessage(alerts, setAlerts, t("Failed to delete column"), "Error");
    }
  };

    const openAddLead = (colId) => {
    // setEditingLead(lead);
    // setOriginalColumnId(colId);
    if (colId) setActiveColumnId(colId); 
    
    setIsSliderOpen('add');
  };


  /** ============= COLUMN TITLE / COLOR / CREATE ============= */
  const [editingColumnId, setEditingColumnId] = useState(null);
  const [tempColumnTitle, setTempColumnTitle] = useState("");
  const inputRef = useRef(null);
  const menuRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(null);

  const handleNewColumn = async () => {
    const id = `col_${Date.now()}`;
    const title = "New Column";
    const color = "#2E86DE";

    const newCols = {
      ...columns,
      [id]: { id, title, items: [], color },
    };

    setColumns(newCols);
    setColumnOrder([...columnOrder, id]);

    try {
      await b.createColumn(selectedQuestId, id, title, color, shareToken);
    } catch (err) {
      console.error("Failed to create column", err);
      setColumns(columns);
      setColumnOrder(columnOrder);
      alertMessage(alerts, setAlerts, t("Failed to add column"), "Error");
    }
  };

  const startEditingColumn = (colId, currentTitle) => {
    setEditingColumnId(colId);
    setTempColumnTitle(currentTitle);
    setOpenMenu(null);
    setTimeout(() => inputRef.current?.focus(), 50);
  };

  const saveColumnTitle = async () => {
    if (!editingColumnId) return;
    const newTitle = (tempColumnTitle || "").trim() || t("Untitled Column");

    setColumns((prev) => ({
      ...prev,
      [editingColumnId]: { ...prev[editingColumnId], title: newTitle },
    }));
    const colId = editingColumnId;
    setEditingColumnId(null);

    try {
      await b.updateColumn({ questId: selectedQuestId, columnId: colId, title: newTitle, shareToken });
    } catch (err) {
      console.error("updateColumn title failed", err);
      alertMessage(alerts, setAlerts, t("Failed to rename column"), "Error");
    }
  };

  const changeColumnColor = async (colId, color) => {
    setColumns((prev) => ({ ...prev, [colId]: { ...prev[colId], color } }));
    try {
      await b.updateColumn({ questId: selectedQuestId, columnId: colId, color, shareToken });
    } catch (err) {
      console.error("updateColumn color failed", err);
      alertMessage(alerts, setAlerts, t("Failed to update color"), "Error");
    }
  };

  const handleColumnTitleKeyDown = (e) => {
    if (e.key === "Enter") saveColumnTitle();
    if (e.key === "Escape") setEditingColumnId(null);
  };

  /** ============= FILTER & SEARCH HANDLERS ============= */
  const resetBoardAndLeads = (searchValue = "") => {

    console.log('CALLEDDDDDD');
    
    Object.keys(columns || {}).forEach((colId) => {
      loadColumn(colId, true, searchValue);
    });
    loadLeadBatch(0);
  };

const removeLeadFromBoard = (leadId) => {
  removeLeadsFromBoard([leadId]);
};

const removeLeadsFromBoard = (leadIds = []) => {
  if (!leadIds.length) return;

  const leadIdSet = new Set(leadIds.map(String));

  setColumns(prev => {
    const updated = {};

	    Object.keys(prev).forEach(colId => {
	      const previousItems = prev[colId].items || [];
	      const nextItems = previousItems.filter(
	        (lead) => !leadIdSet.has(String(lead._id || lead.id))
	      );

	      updated[colId] = {
	        ...prev[colId],
	        items: nextItems,
	        leadCount: Math.max(
	          0,
	          Number(prev[colId].leadCount ?? previousItems.length) - (previousItems.length - nextItems.length)
	        )
	      };
	    });

    return updated;
  });

  setPagination(prev => ({
    ...prev,
    leads: prev.leads.filter(
      (lead) => !leadIdSet.has(String(lead._id || lead.id))
    )
  }));

  setLeadColumnMap(prev => {
    const next = { ...prev };
    leadIds.forEach((leadId) => {
      delete next[String(leadId)];
    });
    return next;
  });
};

const handleBulkArchive = async (leadIds = []) => {
  if (!leadIds.length) return false;

  try {
    setBulkActionLoading(true);
    const results = await l.archiveLeads(leadIds);
    const failedCount = results.filter(
      (result) => result.status === "rejected" || result.value === false
    ).length;

    const successIds = leadIds.filter((_, index) => {
      const result = results[index];
      return result?.status === "fulfilled" && result?.value !== false;
    });

    if (successIds.length) {
      removeLeadsFromBoard(successIds);
    }

    if (!failedCount) {
      alertMessage(alerts, setAlerts, t("Leads archived"), "Success");
      setBulkActionLoading(false);
      return true;
    }

    alertMessage( alerts, setAlerts, t("Some leads could not be archived"),"Error");
    setBulkActionLoading(false);
    return successIds.length > 0;
  } catch (err) {
    console.error("Bulk archive failed", err);
    alertMessage(alerts, setAlerts, t("Failed to archive leads"), "Error");
    setBulkActionLoading(false);
    return false;
  }
};

const handleBulkDelete = async (leadIds = []) => {
  if (!leadIds.length) return false;

  try {
    setBulkActionLoading(true);
    const results = await l.deleteLeads(leadIds);
    const failedCount = results.filter(
      (result) => result.status === "rejected" || result.value === false
    ).length;

    const successIds = leadIds.filter((_, index) => {
      const result = results[index];
      return result?.status === "fulfilled" && result?.value !== false;
    });

    if (successIds.length) {
      removeLeadsFromBoard(successIds);
    }

    if (!failedCount) {
      alertMessage(alerts, setAlerts, t("Leads deleted permanently"), "Success");
      setBulkActionLoading(false);
      return true;
    }

    alertMessage( alerts, setAlerts,t("Some leads could not be deleted"),"Error" );

    setBulkActionLoading(false);
    return successIds.length > 0;
  } catch (err) {
    console.error("Bulk delete failed", err);
    alertMessage(alerts, setAlerts, t("Failed to delete leads"), "Error");
    setBulkActionLoading(false);
    return false;
  }
};

const toggleLeadSelection = (leadId) => {
  const normalizedLeadId = String(leadId);

  setSelectedLeadIds((prev) =>
    prev.includes(normalizedLeadId)
      ? prev.filter((id) => id !== normalizedLeadId)
      : [...prev, normalizedLeadId]
  );
};

const toggleSelectAllVisible = (ids = visibleLeadIds) => {
  const normalizedIds = ids.map(String);
  if (!normalizedIds.length) return;

  setSelectedLeadIds((prev) => {
    const isAllSelected = normalizedIds.every((id) => prev.includes(id));

    if (isAllSelected) {
      return prev.filter((id) => !normalizedIds.includes(id));
    }

    return Array.from(new Set([...prev, ...normalizedIds]));
  });
};

const exitSelectionMode = () => {
  setSelectionMode(false);
  setSelectedLeadIds([]);
  setConfirmBulkAction(false);
};

const runBulkAction = async () => {
  if (!confirmBulkAction || !selectedLeadIds.length) return;

  const success = confirmBulkAction === "archive"
    ? await handleBulkArchive(selectedLeadIds)
    : await handleBulkDelete(selectedLeadIds);

  if (success) {
    exitSelectionMode();
    return;
  }

  setConfirmBulkAction(false);
};


const updateBoardWithNewLead = (lead, colId) => {
    setColumns(prev => {
      const updated = { ...prev };
      const col = updated[colId];
      if (!col) return prev;

      const exists = (col.items || []).some(
        l => String(l._id || l.id) === String(lead._id)
      );
      if (exists) return prev;

	      updated[colId] = {
	        ...col,
	        items: [lead, ...(col.items || [])],
	        leadCount: Number(col.leadCount ?? col.items?.length ?? 0) + 1,
	      };

      return updated;
    });

    setPagination(prev => ({
      ...prev,
      leads: [lead, ...(prev.leads || [])],
    }));

    setLeadColumnMap(prev => ({
      ...prev,
      [String(lead._id)]: colId,
    }));
};

const syncLeadInBoard = (lead) => {
    if (!lead?._id) return;

    setColumns((prev) => {
      const updated = { ...prev };
      let hasChanges = false;

      Object.keys(updated).forEach((colId) => {
        const items = updated[colId]?.items || [];
        let columnChanged = false;
        const nextItems = items.map((item) => {
          if (String(item._id || item.id) !== String(lead._id)) return item;
          columnChanged = true;
          hasChanges = true;
          return { ...item, ...lead };
        });

        if (columnChanged) {
          updated[colId] = {
            ...updated[colId],
            items: nextItems,
          };
        }
      });

      return hasChanges ? updated : prev;
    });

    setPagination((prev) => ({
      ...prev,
      leads: (prev.leads || []).map((item) =>
        String(item._id || item.id) === String(lead._id)
          ? { ...item, ...lead }
          : item
      ),
    }));

};

  const handleSearch = (value) => {
    setSearchQuery(value);
    if (searchTimer.current) clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      resetBoardAndLeads(value);
    }, 300);
  };

  const applyFilter = (type, start = null, end = null, renderedDates) => {
    if (type === "custom") {
      setDateFilters({ value: "custom", slider: false });
      setCustomRange({ start, end, renderedDates });
    } else {
      setDateFilters({ value: type, slider: false });
      setCustomRange({ start: null, end: null });
    }
    setPendingFilterRefresh(true);
  };

  /** ============= EXPORT ALL LEADS ============= */
  const get_all_leads = async () => {
    const [res, boardRes] = await Promise.all([
      l.getPaginatedLeads(selectedQuestId, 0, false, customRange?.start, customRange?.end, callFilters, sourceFilter),
      b.getBoard(selectedQuestId, undefined, undefined, shareToken),
    ]);
    if (!res?.data?.leads || !boardRes?.data?.board?.columns) {
      alertMessage(alerts, setAlerts, t("Export failed"), "Error");
      return;
    }
    const leads = res.data.leads;
    if (!leads.length) {
      alertMessage(alerts, setAlerts, t("No leads found"), "Error");
      return;
    }
    const columnTitles = {};
    Object.values(boardRes.data.board.columns).forEach(column => {
      (column.items || []).forEach(id => { columnTitles[id] = column.title || ""; });
    });
    exportCrmLeads(leads, { t, formSchema, columnTitles, fileName: "leads" });
    alertMessage(alerts, setAlerts, t("Exported all leads successufully"), "Success");
  };


  const fetch_archived_leads = async ({ reset = false } = {}) => {
    setArchivedState(prev => {  
      if (prev.loading) return prev;
      if (!prev.hasMore && !reset) return prev;
      return { ...prev, loading: true };
    });

  try {
    const res = await l.getArchivedLeads({
      questId: selectedQuestId,
      skip: reset ? 0 : archivedState?.skip,
      limit: 30,
      // search,
      // startDate,
      // endDate,
    });
    const items = res?.data?.items || [];
    const hasMore = res?.data?.hasMore;

    setArchivedState(prev => ({
      items: reset ? items : [...prev.items, ...items],
      skip: reset ? items.length : prev.skip + items.length,
      hasMore,
      loading: false,
    }));
  } catch (err) {
    console.error("Failed to load archived leads", err);
    setArchivedState(prev => ({ ...prev, loading: false }));
  }
};

const handleArchivedScroll = (e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;

  if (scrollHeight - scrollTop <= clientHeight + 50) {
    fetch_archived_leads();
  }
};


  /** ============= EFFECTS ============= */

  console.log('formSchema', formSchema);
  
  // Close column menu on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Persist CRM view
  useEffect(() => {
    localStorage.setItem("crm_view", view);
  }, [view]);

  useEffect(() => {
    if (shareToken && !selectedQuest && view !== "kanban") {
      setView("kanban");
    }
  }, [selectedQuest, shareToken, view]);

  // Apply filters when date/custom range changes
  useEffect(() => {
    if (!pendingFilterRefresh) return;
    resetBoardAndLeads(searchQuery);
    setPendingFilterRefresh(false);
  }, [dateFilters, customRange, callFilters, sourceFilter, pendingFilterRefresh]);

  const canLoadTableLeads = !shareToken || Boolean(selectedQuest);

  // Board-list polling replaces selectedQuest even when the board is unchanged.
  // Reset pagination only when the board or its sharing access changes.
  useEffect(() => {
    if (!selectedQuestId || !canLoadTableLeads) return;
    loadLeadBatch(0);
  }, [selectedQuestId, shareToken, canLoadTableLeads]);

  useEffect(() => {
    setSelectedLeadIds((prev) =>
      prev.filter((leadId) => visibleLeadIds.includes(leadId))
    );
  }, [view, pagination?.leads, columns, columnOrder]);

  useEffect(() => {
    exitSelectionMode();
  }, [selectedQuestId]);

  useEffect(() => {
  if (isSliderOpen === "archived") {
    setArchivedState({ items: [], skip: 0,  hasMore: true, loading: false, });
    fetch_archived_leads({ reset: true });
  }
}, [isSliderOpen, selectedQuestId]);


  console.log('BOARD', columns, columnOrder);
  console.log('LEADS', pagination.leads);
  console.log('Notes',editingLead, localNotes);
  console.log('Quests', quests);
  
  
  console.log('isSliderOpen', isSliderOpen, activeColumnId);
  
  /** ============= RENDER ============= */

  return (
    <>
      <GlobalPatch />
      {confirmBulkAction && (
        <Confirmation_
          message={
            confirmBulkAction === "archive"
              ? t("Are you sure you want to archive the selected leads?")
              : t("Are you sure you want to delete the selected leads permanently?")
          }
          onYes={runBulkAction}
          onNo={() => !bulkActionLoading && setConfirmBulkAction(false)}
        />
      )}
      {columnDlt !== false && (
        <Confirmation_
          message={t("Are you sure you want to delete this column?")}
          onYes={deleteColumn}
          onNo={() => setColumnDlt(false)}
        />
      )}
      {!boardReady && <Main_Loader />}
      <Alert_ />
      <Crm_Share_Panel
        sharePanelOpen={sharePanelOpen}
        effectiveSharePanelMode={effectiveSharePanelMode}
        shareLoading={shareLoading}
        handleShareBoard={handleShareBoard}
        closeSharePanel={closeSharePanel}
        displayBoardName={displayBoardName}
        shareLimitReached={shareLimitReached}
        remainingCollaboratorSlots={remainingCollaboratorSlots}
        shareStatus={shareStatus}
        shareEmail={shareEmail}
        onShareEmailChange={(e) => {
          setShareEmail(e.target.value);
          if (shareStatus?.type === "error" || shareStatus?.type === "warning") setShareStatus(null);
        }}
        onShareEmailKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            addPendingShareEmail();
          }
        }}
        pendingShareEmails={pendingShareEmails}
        addPendingShareEmail={addPendingShareEmail}
        removePendingShareEmail={removePendingShareEmail}
        shareEmailHasFormatError={Boolean(shareEmail && !isValidEmailAddress(shareEmail))}
        ownerPanelName={ownerPanelName}
        ownerPanelEmail={ownerPanelEmail}
        ownerResolvedName={ownerResolvedName}
        currentUserEmail={currentUserEmail}
        collaboratorListUsers={collaboratorListUsers}
        handleUnshareBoard={handleUnshareBoard}
        linkSharingEnabled={linkSharingEnabled}
        handleToggleLinkSharing={handleToggleLinkSharing}
        handleCopyBoardLink={handleCopyBoardLink}
      />
      <CrmWrapper>
        {loadError && !boardMeta ? <p role="alert">{t(loadError)}</p> : null}
        {listAvailabilityWarning ? <p role="status">{t(listAvailabilityWarning)}</p> : null}
        {schemaError ? <div role="alert">{t(schemaError)}<Grey_ text={t('Retry')} onClick={reloadSchema} /></div> : null}
        {schemaLoading && isSliderOpen ? <Partial_Loader /> : null}
        <Crm>
          {/* Date slider modal */}
          {dateFilters.slider && (
            <Crm_Leads_Date
              customRange={customRange}
              setCustomRange={setCustomRange}
              callFilters={callFilters}
              setCallFilters={setCallFilters}
              scheduleUsers={sharedBoardPreviewUsers}
              onClose={() => setDateFilters({ ...dateFilters, slider: false })}
              onDone={() => {
                setDateFilters({ ...dateFilters, slider: false });
                applyFilter(customRange?.type || dateFilters.value || "all",customRange.start, customRange.end,customRange?.renderedDates);
              }}
              registerColumnUpdater={(updateFn) => {crmColumnUpdateRef.current = updateFn;}}
            />
          )}

          {/***********SLIDERS***********/}
          {/* Lead editor */}
          {isSliderOpen === 'edit' && hasLoadedFormSchema ? (
            <Crm_Edit_Lead
              editingLead={editingLead}
              initialTab={leadEditorInitialTab}
              setEditingLead={setEditingLead}
              onLeadPatched={syncLeadInBoard}
              saveLead={(leadOverride, options) => saveLead(leadOverride, options)}
              activeColumnId={activeColumnId}
              setActiveColumnId={setActiveColumnId}
              originalColumnId={originalColumnId}
              setOriginalColumnId={() => {}}
              columnOrder={columnOrder}
              columns={columns}
              moveLeadBetweenColumns={moveLeadBetweenColumns}
              onClose={closeLeadEditor}
              updateLeadColumn={crmColumnUpdateRef.current} 
              quests={quests}
              formSchema={formSchema}
              isStandaloneBoard={Boolean(selectedQuest?.isStandaloneBoard || boardMeta?.kind === 'standalone')}
              scheduleUsers={sharedBoardPreviewUsers}
              removeLeadFromBoard={(leadId)=> removeLeadFromBoard(leadId)}
            />
          )
          : isSliderOpen === 'add' && hasLoadedFormSchema ?
            <Crm_Create_Lead 
              onLeadCreated={(createdLead, colId) => updateBoardWithNewLead(createdLead, colId)}
              activeColumnId={activeColumnId}
              setActiveColumnId={setActiveColumnId}
              originalColumnId={originalColumnId}
              setOriginalColumnId={() => {}}
              columnOrder={columnOrder}
              columns={columns}
              moveLeadBetweenColumns={moveLeadBetweenColumns}
              onClose={()=> setIsSliderOpen(false)}
              updateLeadColumn={crmColumnUpdateRef.current} 
              quests={quests}
              removeLeadFromBoard={(leadId)=> removeLeadFromBoard(leadId)}
              formSchema={formSchema}
              selectedQuestId={selectedQuestId}
              isStandaloneBoard={Boolean(selectedQuest?.isStandaloneBoard || boardMeta?.kind === 'standalone')}
              scheduleUsers={sharedBoardPreviewUsers}
              localNotes={localNotes}
              setLocalNotes={setLocalNotes}
            />
          :isSliderOpen === 'archived' ?
            <Crm_Archived_Leads
              onClose={() => setIsSliderOpen(false)}
              selectedQuestId={selectedQuestId}
              archivedLeads ={archivedState.items}
              // handleArchivedScroll={handleArchivedScroll}
              fetchMoreArchivedLeads={fetch_archived_leads}
              hasMore={archivedState.hasMore}
              loading={archivedState.loading}
              openLeadEditor={openLeadEditor}
              onLeadRestored={() => resetBoardAndLeads(searchQuery)}
              updateBoardWithNewLead={(lead, colId) => updateBoardWithNewLead(lead, colId)}
              removeFromArchives={(leadId) =>
                setArchivedState(prev => ({ ...prev, items: prev.items.filter(l => l._id !== leadId)}))
              }
              removeManyFromArchives={(leadIds) =>
                setArchivedState(prev => ({
                  ...prev,
                  items: prev.items.filter((lead) => !leadIds.includes(lead._id))
                }))
              }
              // openLeadEditor(col.id, lead)
              //  startEditingColumn={() => startEditingColumn(col.id, col.title)}
            />
          :isSliderOpen === 'restore' ?
            <Crm_Restore_Leads
              onClose={() => setIsSliderOpen(false)}
              questId={selectedQuestId}
              onRestored={() => {
                loadBoard();
                loadLeadBatch(0);
              }}
            />
          : isSliderOpen === 'import' && hasLoadedFormSchema ? (
            <Crm_Import_Leads
              isStandaloneBoard={Boolean(selectedQuest?.isStandaloneBoard || boardMeta?.kind === 'standalone')}
              onClose={() => setIsSliderOpen(false)}
              formSchema={formSchema}
              selectedQuestId={selectedQuestId}
              columnOrder={columnOrder}
              columns={columns}
              onImportComplete={() => resetBoardAndLeads(searchQuery)}
            />
          )
          : null
        } 
        {/***********SLIDERS***********/}
  

        {!boardReady && <Partial_Loader />}

          {/* TITLE BAR */}
          
          <CrmTitle cta>
            <CrmActionsRight active={showSearch}>
              <Grey_Link iconLeft="Back" text="" noPadding onClick={()=>navigate(`/${lang}/crm`)} />
                <div>
                  <h3> {displayBoardName} </h3>
                  {/* <p>{getQuestName().page}</p> */}
                </div>
            </CrmActionsRight>
        
              <CrmActions>
              {isBoardOwner ? (
                <ShareBoardTrigger>
                  <ShareAvatarStack>
                    {desktopOwnerPreview.visibleUsers.map((userValue, index) => (
                      <ShareAvatar
                        key={`${getRenderableEmail(userValue?.email)}-${index}`}
                        index={index}
                        zIndex={10 + index}
                        background={userValue?.isOwner ? "var(--main)" : "#f4c7a1"}
                        color={userValue?.isOwner ? "var(--white)" : "#5d3415"}
                        border={userValue?.isOwner ? "2px solid var(--white)" : "2px solid #f4c7a1"}
                        onClick={(event) => openCollaboratorCard(event, userValue)}
                      >
                        <img
                          src={getCollaboratorAvatarSrc(userValue)}
                          alt={userValue?.name || getRenderableEmail(userValue?.email)}
                        />
                      </ShareAvatar>
                    ))}
                    {desktopOwnerPreview.hasOverflow ? (
                      <ShareAvatar
                        index={desktopOwnerPreview.visibleUsers.length}
                        zIndex={10 + desktopOwnerPreview.visibleUsers.length}
                        background="var(--greyLight)"
                        color="var(--greyDark)"
                        border="2px solid transparent"
                        as="div"
                        style={{ cursor: "default" }}
                      >
                        <p>...</p>
                      </ShareAvatar>
                    ) : null}
                  </ShareAvatarStack>

                  <ShareBtn size="small" onClick={openSharePanel}>
                    <h5>{t("Share")}</h5>
                    <IconSvg Icon="AddUser" />
                  </ShareBtn>
                </ShareBoardTrigger>
              ) : !isBoardOwner && (selectedQuest || shareToken) ? (
                <SharedBoardPill>
                  {desktopCollaboratorPreview.visibleUsers.length ? (
                    <ShareAvatarStack>
                      {desktopCollaboratorPreview.visibleUsers.map((userValue, index) => (
                        <ShareAvatar
                          key={`${getRenderableEmail(userValue?.email)}-${index}`}
                          index={index}
                          zIndex={10 + index}
                          background="#f4c7a1"
                          color="#5d3415"
                          border="2px solid #f4c7a1"
                          onClick={(event) => openCollaboratorCard(event, userValue)}
                        >
                          <img
                            src={getCollaboratorAvatarSrc(userValue)}
                            alt={userValue?.name || getRenderableEmail(userValue?.email)}
                          />
                        </ShareAvatar>
                      ))}
                      {desktopCollaboratorPreview.hasOverflow ? (
                        <ShareAvatar
                          index={desktopCollaboratorPreview.visibleUsers.length}
                          zIndex={10 + desktopCollaboratorPreview.visibleUsers.length}
                          background="var(--greyLight)"
                          color="var(--greyDark)"
                          border="2px solid transparent"
                          as="div"
                          style={{ cursor: "default" }}
                        >
                          <p>...</p>
                        </ShareAvatar>
                      ) : null}
                    </ShareAvatarStack>
                  ) : null}
                  <ShareTriggerText>
                    <p>{shareToken ? t("Shared via link") : t("Shared with you")}</p>
                    {/* <p>
                      {sharedBoardPreviewUsers.length > 1
                        ? t("{{count}} collaborators", { count: sharedBoardPreviewUsers.length })
                        : t("Private to only me")}
                    </p> */}
                  </ShareTriggerText>
                </SharedBoardPill>
              ) : null}

              <SearchWrapper active={showSearch}>
                <InputReveal
                  active={showSearch}
                  value={searchQuery}
                  placeholder={t("Search leads...")}
                  onChange={e => handleSearch(e.target.value)}
                  onBlur={onBlurHandler}
                  autoFocus={showSearch}
                />
                <Grey_ iconLeft='Search' onClick={onSearchToggle}/>
              </SearchWrapper>
            </CrmActions>
          </CrmTitle>
          {activeCollaboratorCard && createPortal(
            <CollaboratorCard
              ref={collaboratorCardRef}
              style={{ top: activeCollaboratorCard.top, left: activeCollaboratorCard.left }}
            >
              <CollaboratorCardTop>
                <CollaboratorCardAvatar
                  background={activeCollaboratorCard.user.background}
                  color={activeCollaboratorCard.user.color}
                  border={activeCollaboratorCard.user.border}
                >
                  <img
                    src={activeCollaboratorCard.user.avatarSrc}
                    alt={activeCollaboratorCard.user.displayName}
                  />
                </CollaboratorCardAvatar>
                <div>
                  <h4>{activeCollaboratorCard.user.displayName}</h4>
                  <p>{activeCollaboratorCard.user.email}</p>
                </div>
              </CollaboratorCardTop>

              <CollaboratorCardBody>
                <CollaboratorCardRow>
                  <h6>{t("Role")}</h6>
                  <p>{activeCollaboratorCard.user.role}</p>
                </CollaboratorCardRow>
                <CollaboratorCardRow>
                  <h6>{t("Board access")}</h6>
                  <p>{t("Can access this board")}</p>
                </CollaboratorCardRow>
              </CollaboratorCardBody>
            </CollaboratorCard>,
            document.body
          )}

          {/* QUEST DROPDOWN */}
        <CrmQuestSelect>
            {questsLoading ? (
              <Partial_Loader />
            ) : (
            <Crm_Board_Actions
              isSidequest={Boolean(selectedQuest?.isSidequest || selectedQuest?.isStandaloneBoard)}
              selectionMode={selectionMode}
              view={view}
              setView={setView}
              bulkActionLoading={bulkActionLoading}
              exitSelectionMode={exitSelectionMode}
              allVisibleSelected={allVisibleSelected}
              toggleSelectAllVisible={toggleSelectAllVisible}
              selectedLeadIds={selectedLeadIds}
              setConfirmBulkAction={setConfirmBulkAction}
              newActionsRef={newActionsRef}
              moreActions={moreActions}
              setMoreActions={setMoreActions}
              openAddLead={openAddLead}
              columnOrder={columnOrder}
              setIsSliderOpen={setIsSliderOpen}
              dateFilters={dateFilters}
              setDateFilters={setDateFilters}
              activeFilterCount={activeFilterCount}
              setSelectionMode={setSelectionMode}
              desktopMoreActionsRef={desktopMoreActionsRef}
              mobileMoreActionsRef={mobileMoreActionsRef}
              get_all_leads={get_all_leads}
              isBoardOwner={isBoardOwner}
              openSharePanel={openSharePanel}
              mobileOwnerPreview={mobileOwnerPreview}
              mobileCollaboratorPreview={mobileCollaboratorPreview}
              getRenderableEmail={getRenderableEmail}
              getCollaboratorAvatarSrc={getCollaboratorAvatarSrc}
            />
        )}
        
        </CrmQuestSelect>
          {/* NO COLUMNS / EMPTY BOARD */}
          {Object.keys(columns).length === 0 ? (
            <CrmLeadsNo>
              <img src="https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Empty.svg" alt="" />
              <h1>{t("No leads available")}</h1>
              <h5> {t( "There are no available leads to show at the moment. Come back later to check again!" )} </h5>
            </CrmLeadsNo>
          ) : view === "kanban" ? (
            /* ====================== KANBAN VIEW ====================== */
            <CrmBoardWrapper
              onMouseDown={onMouseDown}
              onMouseMove={onMouseMove}
              onMouseUp={onMouseUp}
              onMouseLeave={onMouseUp}
            >
              <Crm_Kanban_Board
                boardRef={boardRef}
                columnOrder={columnOrder}
                columns={columns}
                columnHasMore={columnHasMore}
                columnLoading={columnLoading}
                onDragEnd={onDragEnd}
                openAddLead={openAddLead}
                openLeadEditor={openLeadEditor}
                handleNewColumn={handleNewColumn}
                loadColumn={loadColumn}
                editingColumnId={editingColumnId}
                tempColumnTitle={tempColumnTitle}
                setTempColumnTitle={setTempColumnTitle}
                inputRef={inputRef}
                handleColumnTitleKeyDown={handleColumnTitleKeyDown}
                saveColumnTitle={saveColumnTitle}
                startEditingColumn={startEditingColumn}
                openMenu={openMenu}
                setOpenMenu={setOpenMenu}
                changeColumnColor={changeColumnColor}
                setColumnDlt={setColumnDlt}
                menuRef={menuRef}
                t={t}
                isDraggingCardRef={isDraggingCardRef}
                selectionMode={selectionMode}
                selectedLeadIds={selectedLeadIds}
                toggleLeadSelection={toggleLeadSelection}
              />
            </CrmBoardWrapper>
          ) : (
            /* ====================== TABLE VIEW ====================== */
            <CrmBoardWrapper>
              <CrmTableView
                columns={columns}
                loadLeadBatch={loadLeadBatch}
                leadColumnMap={leadColumnMap}
                multipleCustomFields={multipleCustomFields}
                openLeadEditor={openLeadEditor}
                pagination={pagination}
                selectedLeadIds={selectedLeadIds}
                selectedQuestId={selectedQuestId}
                setLeadColumnMap={setLeadColumnMap}
                setPagination={setPagination}
                selectionMode={selectionMode}
                toggleLeadSelection={toggleLeadSelection}
                toggleSelectAllVisible={toggleSelectAllVisible}
              />
            </CrmBoardWrapper>
          )}
        </Crm>
      </CrmWrapper>
    </>
  );
}
